export default __webpack_public_path__ + "static/media/sajmeta.0c7f5064.jpg";